import { render, staticRenderFns } from "./veStuAssocActivityRecordShow.vue?vue&type=template&id=c704bd70&scoped=true"
import script from "./veStuAssocActivityRecordShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocActivityRecordShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c704bd70",
  null
  
)

export default component.exports